import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import {
  getExamainationTemplatesList,
  deleteExaminationTemplate,
  updateExaminationTemplateStatus,
  getFormsList,
} from "../../../services/Users-services.js";
import { useGlobalState } from "../../../services/hostelConst.js";
import { getOrganizationLevel } from "../../../services/OrganisationServices/organizationLevel";
import React, { useEffect, useState } from "react";
import AddGroupForm from "../../FormComponents/AddGroups";
import { showErrorMessages } from "../../../services/utilityFunctions";
import { useNavigate } from "react-router-dom";
import AddExaminationTemplateForm from "./AddExaminationTemplateForm.js";
const ExaminationTemplatesTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    triggerChildSidebar,
  } = useGlobalState();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
   
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    setIsInitialized(true);

    return () => {};
  }, []);
  return !isInitialized ? (
    <div></div>
  ) : (
    <MasterTable
      getTableData={getExamainationTemplatesList}
      updateStatus={updateExaminationTemplateStatus}
      deleteRow={deleteExaminationTemplate}
      tab1={"Examination"}
      tab2={"Templates"}
      actions={{
        status: false,
        edit: true,
        delete: true,
      }}
      AddForm={AddExaminationTemplateForm}
    />
  );
};

export default ExaminationTemplatesTable;


